import { Button, Space, Typography } from "antd";
import { default as React } from "react";
import copy from "./assets/copy.svg";
import bank from "./assets/bank.png";

const { Title, Text, Paragraph } = Typography;
const ACHPay = () => {
  return (
    <div className="ach-section">
      <Paragraph className="sub-text">
        Use these details to send both domestic wires and ACH transfers to Mark
        Samuel's Zenus account.
      </Paragraph>

      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Space
          direction="horizontal"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <div>
            <Text type="secondary">Routing number</Text>
            <div className="ach attachment-wrap">
              <Text strong>3456787654</Text>
              <Button icon={<img src={copy} width={15} />} type="link" />
            </div>
          </div>
          <div>
            <Text type="secondary">Account number</Text>
            <div className="ach attachment-wrap">
              <Text strong>3456787654</Text>
              <Button icon={<img src={copy} width={15} />} type="link" />
            </div>
          </div>
        </Space>
        <div className="ben-details attachment-wrap">
          {/* Beneficiary */}
          <div className="attachment-item">
            <Title level={5}>
              <img src={bank} width={18} />
              Beneficiary
            </Title>
            <div>
              <Paragraph>
                <strong>Beneficiary Name:</strong> Mark Samuel
              </Paragraph>
              <Paragraph>
                <strong>Type of account:</strong> Company
              </Paragraph>
              <Paragraph>
                <strong>Beneficiary Address:</strong> 117 Fernwood St,
                Barberton, Ohio(OH), 44203
              </Paragraph>
            </div>
          </div>
          {/* Receiving Bank Details */}
          <div className="attachment-item">
            <Title level={5}>
              <img src={bank} width={18} />
              Receiving Bank Details
            </Title>
            <div>
              <Paragraph>
                <strong>Bank name:</strong>
                <div>
                  Choice Financial Group
                  <p className="dim mtHalf">
                    Zenus uses Choice Financial Group as a banking partner.
                  </p>
                </div>
              </Paragraph>
              <Paragraph>
                <strong>Bank Address:</strong> 3713 Irving Park Ave, Beachwood,
                Ohio(OH), 44122
              </Paragraph>
            </div>
          </div>
        </div>
      </Space>
    </div>
  );
};

export default ACHPay;
